import { urlFor } from "../sanityClient";

// Custom Tailwind-styled components for PortableText (Sanity rich text)
export const portableTextComponents = {
  types: {
    image: ({ value }: any) => {
      const imageUrl = value?.asset ? urlFor(value.asset)?.width(1000).height(560).url() : null;
      return imageUrl ? (
        <figure className="my-8">
          <img
            src={imageUrl}
            alt={value?.alt || "Blog image"}
            className="w-full h-auto rounded-2xl border border-gray-100"
          />
          {value?.caption && (
            <figcaption className="text-center text-brand/50 mt-3 text-sm">{value.caption}</figcaption>
          )}
        </figure>
      ) : null;
    },
  },
  block: {
    h1: ({ children }: any) => <h1 className="text-3xl font-bold text-brand mt-10 mb-4">{children}</h1>,
    h2: ({ children }: any) => <h2 className="text-2xl font-bold text-brand mt-10 mb-4">{children}</h2>,
    h3: ({ children }: any) => <h3 className="text-xl font-bold text-brand mt-8 mb-3">{children}</h3>,
    h4: ({ children }: any) => <h4 className="text-lg font-bold text-brand mt-6 mb-2">{children}</h4>,
    h5: ({ children }: any) => <h5 className="text-base font-bold text-brand mt-4 mb-2">{children}</h5>,
    h6: ({ children }: any) => <h6 className="text-sm font-bold text-brand mt-4 mb-2">{children}</h6>,
    normal: ({ children }: any) => <p className="mb-4 leading-relaxed text-brand/80">{children}</p>,
    blockquote: ({ children }: any) => (
      <blockquote className="border-s-4 border-lime ps-5 py-1 my-6 text-brand/70 italic">
        {children}
      </blockquote>
    ),
  },
  marks: {
    strong: ({ children }: any) => <strong className="font-bold text-brand">{children}</strong>,
    em: ({ children }: any) => <em>{children}</em>,
    underline: ({ children }: any) => <u>{children}</u>,
    strikeThrough: ({ children }: any) => <s>{children}</s>,
    code: ({ children }: any) => (
      <code className="bg-gray-100 text-brand px-1.5 py-0.5 rounded text-sm font-mono">{children}</code>
    ),
    link: ({ value, children }: any) => {
      const target = (value?.href || "").startsWith("http") ? "_blank" : undefined;
      return (
        <a
          href={value?.href}
          target={target}
          rel={target === "_blank" ? "noopener noreferrer" : undefined}
          className="text-brand-teal font-medium underline underline-offset-2 hover:text-brand transition-colors"
        >
          {children}
        </a>
      );
    },
  },
  list: {
    bullet: ({ children }: any) => <ul className="list-disc ps-6 mb-4 space-y-1.5 text-brand/80">{children}</ul>,
    number: ({ children }: any) => <ol className="list-decimal ps-6 mb-4 space-y-1.5 text-brand/80">{children}</ol>,
  },
  listItem: {
    bullet: ({ children }: any) => <li className="leading-relaxed">{children}</li>,
    number: ({ children }: any) => <li className="leading-relaxed">{children}</li>,
  },
};

export default portableTextComponents;
